import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '@components/Heading';

export const CoinTransactionsHeading = () => {
  const { t } = useTranslation();

  return <Heading level="h2">{t('myCoinsPage.transactions.heading')}</Heading>;
};
